import React, { useState, useEffect } from "react";

export default function MultiSelect({
  options = [],
  onChange = () => {},
  title = null,
  selectedList = [], // ✅ new prop for pre-selected items
}) {
  const [selected, setSelected] = useState([]);

  // ✅ initialize with pre-selected values
  useEffect(() => {
    setSelected(selectedList);
  }, []);

  const toggleSelect = (option) => {
    let newSelected;
    if (selected.includes(option)) {
      newSelected = selected.filter((item) => item !== option);
    } else {
      newSelected = [...selected, option];
    }

    setSelected(newSelected);
    onChange(newSelected); // return selected items
  };

  return (
    <div
      style={{
        padding: "16px",
        border: "1px solid #ccc",
        borderRadius: "16px",
        boxShadow: "0px 2px 8px rgba(0,0,0,0.1)",
        maxWidth: "300px",
        fontFamily: "sans-serif",
        color: "white",

      }}
    >
      

      <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
        {options.map((option) => (
          <li
            key={option}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              marginBottom: "8px",
            }}
          >
            <input
              type="checkbox"
              id={option}
              checked={selected.includes(option)}
              onChange={() => toggleSelect(option)}
              style={{ width: "16px", height: "16px", cursor: "pointer" }}
            />
            <label
              htmlFor={option}
              style={{
                cursor: "pointer",
                fontSize: "14px",
                padding: 0,
                color: "white",
                textTransform: "capitalize",
              }}
            >
              {option}
            </label>
          </li>
        ))}
      </ul>

     
    </div>
  );
}
